class BannerWithPinsUnfolder {
  constructor(el) {
    this.el = el;
    this.toggle = el.querySelector('.banner-with-pins__toggle');
    this.content = el.querySelector('.pins__wrapper');
    this.animation = null;
    this.isBusy = false;

    if (!this.toggle || !this.content) return;

    this.toggle.addEventListener('click', (event) => this.onClick(event));

    this.showProductsAlwaysOnMobileDevice =
      this.el.hasAttribute('data-always-show-products-on-mobile') && window.innerWidth < 768;
    if (this.showProductsAlwaysOnMobileDevice) {
      this.setOpen(true);
    }
  }

  isOpen() {
    return this.el.classList.contains('is-open');
  }

  setOpen(open) {
    if (open === this.isOpen()) return;

    this.el.classList.toggle('is-open', open);
    this.toggle.setAttribute('aria-expanded', open ? 'true' : 'false');

    const closedLabel = this.toggle.querySelector('[data-banner-toggle-closed]');
    const openLabel = this.toggle.querySelector('[data-banner-toggle-open]');
    if (closedLabel) closedLabel.hidden = open;
    if (openLabel) openLabel.hidden = !open;

    if (open) {
      this.content.removeAttribute('inert');
    } else {
      this.content.setAttribute('inert', '');
    }
  }

  onClick(event) {
    event.preventDefault();
    event.stopImmediatePropagation();

    if (this.showProductsAlwaysOnMobileDevice || this.isBusy) {
      return;
    }

    this.isBusy = true;
    this.el.style.overflow = 'hidden';

    if (!this.isOpen()) {
      this.setOpen(true);
      if (window.innerWidth >= 768) {
        this.pinsAnimation('translateX(100%)', 'translateX(0)');
      } else {
        this.pinsAnimation('translateY(-100%)', 'translateY(0)');
      }
      this.el.classList.add('pins-animate');
      if (this.animation) {
        this.animation.onfinish = () => this.onAnimationFinish(true);
      } else {
        this.isBusy = false;
      }
    } else {
      if (window.innerWidth >= 768) {
        this.pinsAnimation('translateX(0)', 'translateX(100%)');
      } else {
        this.pinsAnimation('translateY(0)', 'translateY(-100%)');
      }
      this.el.classList.remove('pins-animate');
      if (this.animation) {
        this.animation.onfinish = () => this.onAnimationFinish(false);
      } else {
        this.onAnimationFinish(false);
      }
    }
  }

  pinsAnimation(tranformStart, transformEnd) {
    const inner = this.content.querySelector('.pins__wrapper--inner');
    if (!inner) {
      this.animation = null;
      return;
    }

    this.animation = inner.animate(
      {
        transform: [tranformStart, transformEnd],
      },
      {
        duration: 400,
        easing: 'ease-out',
      },
    );
  }

  onAnimationFinish(open) {
    this.setOpen(open);
    this.animation = null;
    this.isBusy = false;
    this.el.style.width = this.el.style.overflow = '';
  }
}

document.querySelectorAll('.banner-with-pins').forEach((el) => {
  new BannerWithPinsUnfolder(el);
});
